import { useQuery } from '@tanstack/react-query';
import { postInvitationsStatus } from 'api/requests/requests';

export const invitationsQueryKeys = {
  all: ['invitations'] as const,
  status: (uuid: string) => [...invitationsQueryKeys.all, 'status', uuid] as const,
};

export function useInvitationsStatusQuery(uuid?: string) {
  return useQuery({
    queryKey: invitationsQueryKeys.status(uuid!),
    queryFn: () => postInvitationsStatus(uuid!),
    enabled: uuid != null,
    select: ({ data }) => data,
  });
}
